import { Pipe, PipeTransform } from '@angular/core';
import { CardModel, EquipmentTypeModel } from 'src/app/models';

@Pipe({ name: 'toEquipmentTypeCards' })
export class EquipmentTypeCardsPipe implements PipeTransform {
  transform(values: EquipmentTypeModel[]): CardModel[] {
    return values?.map((typeModel) => CardModel.fromEquipmentTypeModel(typeModel));
  }
}
